// GLobal Style for theme
import { makeStyles } from '@material-ui/core/styles';
// Theme Constant 
import { titanStyle } from './titan.theme.constant';
// list block heigth and width
const blockHeight = '25px';
const blockWidth = '60px';
// Global Style for Application
export default makeStyles(theme => ({
    active: {
        color: titanStyle.titan_color.color_darkish_green,
        backgroundColor: titanStyle.titan_color.color_e8f5e9,
        fontSize: titanStyle.titan_fontSize.fontSize_12,
        width: blockWidth,
        height: blockHeight,
        borderRadius: titanStyle.titan_borderRadius.borderRadius_13,
        padding:titanStyle.titan_padding.padding_5,
    },
    inactive: {
        color: titanStyle.titan_color.color_red,
        backgroundColor: titanStyle.titan_color.color_ffcdd2,
        fontSize: titanStyle.titan_fontSize.fontSize_12,
        width: blockWidth,
        height: blockHeight,
        borderRadius: titanStyle.titan_borderRadius.borderRadius_13,
        padding:titanStyle.titan_padding.padding_5,
    },
    actionIcon: {
        cursor: titanStyle.titan_cursorActions.pointer
    },
    padding_1: {
        padding: titanStyle.titan_padding.padding_1,
    },
    padding_2: {
        padding: titanStyle.titan_padding.padding_2,
    },
    padding_3: {
        padding: titanStyle.titan_padding.padding_3,
    },
    padding_4: {
        padding: titanStyle.titan_padding.padding_4,
    },
    padding_5: {
        padding: titanStyle.titan_padding.padding_5,
    },
    padding_6: {
        padding: titanStyle.titan_padding.padding_6,
    },
    padding_7: {
        padding: titanStyle.titan_padding.padding_7,
    },
    padding_8: {
        padding: titanStyle.titan_padding.padding_8,
    },
    padding_9: {
        padding: titanStyle.titan_padding.padding_9,
    },
    padding_10: {
        padding: titanStyle.titan_padding.padding_10,
    },
    padding_11: {
        padding: titanStyle.titan_padding.padding_11,
    },
    padding_12: {
        padding: titanStyle.titan_padding.padding_12,
    },
    padding_13: {
        padding: titanStyle.titan_padding.padding_13,
    },
    padding_14: {
        padding: titanStyle.titan_padding.padding_14,
    },
    padding_15: {
        padding: titanStyle.titan_padding.padding_15,
    },
    padding_16: {
        padding: titanStyle.titan_padding.padding_16,
    },
    padding_17: {
        padding: titanStyle.titan_padding.padding_17,
    },
    padding_18: {
        padding: titanStyle.titan_padding.padding_18,
    },
    padding_19: {
        padding: titanStyle.titan_padding.padding_19,
    },
    padding_20: {
        padding: titanStyle.titan_padding.padding_20,
    }
}));
